import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SuperbuySpreadsheetGuide from "@/pages/guide/page";
import SuperbuySpreadsheetShoesGuide from "@/pages/shoes-guide/page";
import SuperbuySpreadsheetComparison from "@/pages/comparison/page";
import SuperbuySpreadsheetSafety from "@/pages/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/superbuy-spreadsheet-shoes-guide",
    element: <SuperbuySpreadsheetShoesGuide />,
  },
  {
    path: "/comparison",
    element: <SuperbuySpreadsheetComparison />,
  },
  {
    path: "/is-superbuy-spreadsheet-safe",
    element: <SuperbuySpreadsheetSafety />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;